var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoVrboCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "5ist5h6gfa",
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-988 -116) translate(988 116)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hcn7sqanvb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5ist5h6gfa"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#5ist5h6gfa"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hcn7sqanvb)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#7CB985",
    d: "M8.447 12l.341-.927-1.155-7.634C7.311 1.29 7.698.354 9 .03V0H7.796c-.349.226-1.087.903-.674 3.434L8.447 12",
    transform: "translate(4 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB6233",
    d: "M7.55 14l.45-.932-2.024-9.64C5.596 1.559 5.758.586 6.39.03V0H5.298c-.335.7-.435 1.4-.05 3.25L7.548 14",
    transform: "translate(4 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F5998",
    d: "M6.63 15l.37-.873L4.925 3.05C4.56 1.328 4.643.54 4.793 0H4c-.008.932.098 1.86.315 2.76L6.631 15M2.952 0H2v.028c.423.577.55 1.28.889 2.833L5.429 16H6L3.46 2.819C3.241 1.89 3.071.949 2.952 0",
    transform: "translate(4 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#467BB2",
    d: "M1.054 0H0v.028c.962.411 1.435 1.2 1.815 3.047L4.41 16H5L2.388 2.994C1.938.737 1.465.32 1.054 0",
    transform: "translate(4 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F5998",
    d: "M16.107 0C14.662.804 13.802 2.29 12 5.976l.045.024C14.127 2.29 15.313.814 18 .044V0h-1.893",
    transform: "translate(4 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB6233",
    d: "M12 5.97l.048.03C13.816 2.125 14.278 1.044 15 .03V0h-1.431v.04c.147 1.552-.41 2.982-1.569 5.93",
    transform: "translate(4 6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7CB985",
    d: "M11.866 5.97l.047.03c1.138-3.507 1.506-5.055.502-6H11v.03c1.602.524 1.933 2.023.866 5.94",
    transform: "translate(4 6)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVrboCircle);
export default __webpack_public_path__ + "static/media/IcoVrboCircle.dd04d03ae24631d2809b8d6eb9c2dc39.svg";
export { ForwardRef as ReactComponent };